export default {
  install(Vue, options) {
    Vue.prototype.$hasFeature = function (feature) {
      return this.$store.state.user.data.features.includes(feature)
    }
  },
}
